// Annotate each feature flag with owner. Remove here when code references to feature flags are removed and experiments complete
export const FEATURE_FLAGS = {
  NPS_SURVEY_DROPOFF: 'nps-survey-dropoff', // owner: @alexkim205
  CHATPG_ELIGIBILITY_POLLING: 'chatpg-eligibility-polling', // owner: @aalmazan
  NOTIFICATIONS: 'notifications', // owner: @alexkim205 and @aalmazan
  CONVERSATION_INSIGHTS: 'conversation-insights', // owner:@alexkim205
  EMAIL_LATER: 'email-later', // owner: @alexkim205
};
